export default __webpack_public_path__ + "static/VideoEffects-5d3b8a329ddd5e0da4c8749390e5061e.mp4";